// extracted by mini-css-extract-plugin
module.exports = {"form":"AddSubCategory_form__1QthY","innerform":"AddSubCategory_innerform__1NKwc","label-input":"AddSubCategory_label-input__2X6_J","buttondiv":"AddSubCategory_buttondiv__1yXYl"};